/**
 * VixoKart Theme — Hero Slider
 * Features: auto-play, fade transitions, dot navigation, arrow controls, pause on hover
 */

'use strict';

(function initHeroSlider() {
  const slider = document.querySelector('.hero-slider');
  if (!slider) return;

  const slides     = Array.from(slider.querySelectorAll('.hero-slide'));
  const dots       = Array.from(slider.querySelectorAll('.hero-dot'));
  const prevBtn    = slider.querySelector('.hero-slider__arrow--prev');
  const nextBtn    = slider.querySelector('.hero-slider__arrow--next');
  const AUTO_DELAY = parseInt(slider.dataset.autoplay || '5000', 10);

  let current  = 0;
  let timer    = null;
  let paused   = false;

  if (slides.length <= 1) {
    // Single slide, no need for controls
    slides[0]?.classList.add('active');
    return;
  }

  // ─── Go to slide ─────────────────────────────────────────────────────────────

  function goTo(index) {
    slides[current].classList.remove('active');
    dots[current]?.classList.remove('active');

    current = (index + slides.length) % slides.length;

    slides[current].classList.add('active');
    dots[current]?.classList.add('active');
  }

  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }

  // ─── Auto-play ───────────────────────────────────────────────────────────────

  function startAuto() {
    if (paused) return;
    clearInterval(timer);
    timer = setInterval(next, AUTO_DELAY);
  }

  function stopAuto() {
    clearInterval(timer);
    timer = null;
  }

  // ─── Event bindings ──────────────────────────────────────────────────────────

  nextBtn?.addEventListener('click', () => { next(); stopAuto(); startAuto(); });
  prevBtn?.addEventListener('click', () => { prev(); stopAuto(); startAuto(); });

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => { goTo(i); stopAuto(); startAuto(); });
  });

  // Pause on hover / touch
  slider.addEventListener('mouseenter', () => { paused = true; stopAuto(); });
  slider.addEventListener('mouseleave', () => { paused = false; startAuto(); });

  // Touch swipe
  let touchStartX = 0;
  slider.addEventListener('touchstart', e => { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
  slider.addEventListener('touchend', e => {
    const dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 50) {
      dx < 0 ? next() : prev();
      stopAuto();
      startAuto();
    }
  });

  // Keyboard
  slider.addEventListener('keydown', e => {
    if (e.key === 'ArrowLeft')  { prev(); stopAuto(); startAuto(); }
    if (e.key === 'ArrowRight') { next(); stopAuto(); startAuto(); }
  });

  // ─── Init ────────────────────────────────────────────────────────────────────

  goTo(0);
  startAuto();

  // Pause when tab is hidden (battery saving)
  document.addEventListener('visibilitychange', () => {
    document.hidden ? stopAuto() : startAuto();
  });

})();
